import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import conf from '../../conf';

// styles
import { FlexContainerRowLRPadding, NavButtons, PageWrapper } from '../styled/skylab/page';

// types
import type { Props } from '../../containers/signup/setup';

import Banner from '../banner';
import { SetupFormFields } from '../shared/forms/setup';
// components
import { SignUpForm } from '../styled/components/sign-up';
import CheckoutPurchaseInfo from './checkout-purchase-info';

// helpers
import { catchNextClick } from '../helpers/sign-up';

const Setup = ({
  containsInvalidOrMissingFields,
  continueLink,
  continueLinkText,
  isDirectToBuy,
  partnerSignup,
  showThirdBullet,
}: Props) => {
  const { search } = useLocation();
  return (
    <div>
      <Banner
        backgroundImage={`${conf.ASSET_PATH}/assets/images/banner-background.png`}
        image={`${conf.ASSET_PATH}/assets/images/company_w.svg`}
        partnerSignup={partnerSignup}
        primaryText={`Activate your ${isDirectToBuy ? 'account' : 'free trial'} today`}
        secondaryText={isDirectToBuy ? '' : 'Start your free trial today'}
      />
      <PageWrapper>
        <FlexContainerRowLRPadding>
          <div>
            <h3 data-ref='buy.signup.setup-header' className='text-md'>
              {"Tell us about your company, and we'll jump-start your setup"}
            </h3>
            <SignUpForm>
              <SetupFormFields />
              <NavButtons>
                {/* For partner trial flows (like Quickbooks), we don't need to select any connector,
                and can just proceed to signing up the user and redirecting to success.
                API partner trials, however, are an exception.
              */}
                <Link
                  data-ref='buy.signup.setup.next-button'
                  to={`${continueLink}${search}`}
                  onClick={(e) => catchNextClick(e, containsInvalidOrMissingFields)}
                  tabIndex={0}
                >
                  <button
                    type='button'
                    className={'formComplete primary large'}
                    disabled={containsInvalidOrMissingFields}
                    data-ref='buy.signup.continue-signup-button'
                  >
                    {continueLinkText}
                  </button>
                </Link>
              </NavButtons>
            </SignUpForm>
          </div>
          <CheckoutPurchaseInfo
            start={false}
            isDirectToBuy={isDirectToBuy}
            partnerSignup={partnerSignup}
            showThirdBullet={showThirdBullet}
          />
        </FlexContainerRowLRPadding>
      </PageWrapper>
    </div>
  );
};

export default Setup;
